import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AlbumVideoSection } from './components/AlbumVideoSection';
import { SolutionSection } from './components/SolutionSection';
import { ValueStackSection } from './components/ValueStackSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { StickyFooter } from './components/StickyFooter';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-brand-200 selection:text-brand-900" data-id="element-0" data-mp="28ufm24yk52fw">
      <main data-id="element-1" data-mp="23w4fc33k781w">
        <HeroSection data-id="element-2" data-mp="23u9vks40xlze" />
        <PainSection data-id="element-3" data-mp="23v2rey1g2r2r" />
        <AlbumVideoSection data-id="element-4" data-mp="23ti7e2craqj5" />
        <SolutionSection data-id="element-5" data-mp="3ikha0f5th31m" />
        <ValueStackSection data-id="element-6" data-mp="3ij64a9st9l7v" />
        <BonusSection data-id="element-7" data-mp="3ihv2gfixenje" />
        <PricingSection data-id="element-8" data-mp="3mlj8uuvtnd32" />
        <TestimonialsSection data-id="element-9" data-mp="3mkrbpfmkt7ao" />
        <GuaranteeSection data-id="element-10" data-mp="3mjztr7lwj82v" />
        <FAQSection data-id="element-11" data-mp="3mj6k9yvk64h1" />
      </main>
      <StickyFooter data-id="element-12" data-mp="3rbzn2h7gv2qh" />
      <PurchaseNotification data-id="element-13" data-mp="3rdkie91luppe" />
    </div>;
}